<!-- BETA-CLEANUP: delete this file and its spec once Vue 3 is the only app -->
<template>
  <v-tooltip v-if="mini" right>
    <template #activator="{ on, attrs }">
      <v-list-item
        class="user-actions-list-item"
        aria-label="Try the new version"
        data-test="sidebar-open-beta"
        data-track="beta.sidebar.open"
        v-bind="attrs"
        :disabled="isOpeningBeta"
        v-on="on"
        @click="openBeta"
      >
        <v-list-item-icon>
          <v-progress-circular
            v-if="isOpeningBeta"
            indeterminate
            size="20"
            width="2"
            color="primary"
          />
          <BetaRocketIcon v-else class="primary--text" />
        </v-list-item-icon>
      </v-list-item>
    </template>
    <span>Try the new version</span>
    <template v-if="releaseNote">
      <br>
      <span class="caption" data-test="sidebar-beta-release">{{ releaseNote }}</span>
    </template>
  </v-tooltip>
  <div v-else class="px-2 pt-2 text-center">
    <v-btn
      color="primary"
      depressed
      block
      :loading="isOpeningBeta"
      data-test="sidebar-open-beta"
      data-track="beta.sidebar.open"
      @click="openBeta"
    >
      <BetaRocketIcon :size="16" class="mr-2" />
      Try the new version
    </v-btn>
    <div v-if="releaseNote" class="caption grey--text text--lighten-1 mt-1" data-test="sidebar-beta-release">
      {{ releaseNote }}
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

import { getBetaReleaseNote, openBeta } from '@/bundles/App/helpers/betaChannel';

import BetaRocketIcon from '@/bundles/App/components/BetaRocketIcon.vue';

interface IData {
  releaseNote: string;
  isOpeningBeta: boolean;
}

export default Vue.extend({
  name: 'SideBarBetaLink',

  components: { BetaRocketIcon },

  props: {
    // the collapsed rail has room for an icon only
    mini: Boolean,
  },

  data: (): IData => ({
    releaseNote: getBetaReleaseNote(),
    isOpeningBeta: false,
  }),

  methods: {
    async openBeta (): Promise<void> {
      this.isOpeningBeta = true;

      try {
        await openBeta();
      } finally {
        this.isOpeningBeta = false;
      }
    },
  },
});
</script>
